import { useCallback } from "react";
import { runInAction } from "mobx";
import { useToggleConsultantFavouriteMutation } from "@bonliva-crm/graphql";
import { useGlobalStore, useSnackbars } from "@hooks";

export function useToggleConsultantFavourite() {
  const { consultantFavourites } = useGlobalStore();
  const { showError } = useSnackbars();
  const [toggleMutation, { loading }] = useToggleConsultantFavouriteMutation();

  const toggle = useCallback(
    async (consultantId: string) => {
      const previous = consultantFavourites.has(consultantId);
      runInAction(() => consultantFavourites.toggle(consultantId));

      try {
        const { data } = await toggleMutation({ variables: { consultantId } });
        const confirmed = data?.toggleConsultantFavourite ?? !previous;
        runInAction(() => {
          if (confirmed) {
            consultantFavourites.add(consultantId);
          } else {
            consultantFavourites.remove(consultantId);
          }
        });
      } catch (error) {
        runInAction(() => {
          if (previous) {
            consultantFavourites.add(consultantId);
          } else {
            consultantFavourites.remove(consultantId);
          }
        });
        showError((error as Error)?.message ?? String(error));
      }
    },
    [consultantFavourites, showError, toggleMutation]
  );

  return { toggle, loading };
}
